export default "__VITE_ASSET__29ae108b__"